// extracted by mini-css-extract-plugin
export var form = "_55-0";